@if (pageCount > 1) {
  <ul class="table-pagination_list">
    <li class="table-pagination_left-end" [class.-enabled]="currentPage" (click)="setPageIndex(0)">
      <svg class="table-pagination_left-end_icon"><use xlink:href="#double-arrow-pagination"></use></svg>
    </li>
    <li class="table-pagination_left" [class.-enabled]="currentPage" (click)="setPageIndex(currentPage - 1)">
      <svg class="table-pagination_left_icon"><use xlink:href="#arrow-pagination"></use></svg>
    </li>
    @for (pageIndex of pageLinks; track pageIndex) {
      <li class="table-pagination_page"
        [class.-ellipsis]="pageIndex == null"
        [class.-current]="pageIndex === currentPage"
        (click)="pageIndex != null && setPageIndex(pageIndex)">
        <span class="table-pagination_page_label">{{pageIndex == null ? '...' : pageIndex + 1}}</span>
      </li>
    }
    <li class="table-pagination_right" [class.-enabled]="currentPage < pageCount - 1" (click)="setPageIndex(currentPage + 1)">
      <svg class="table-pagination_right_icon"><use xlink:href="#arrow-pagination"></use></svg>
    </li>
    <li class="table-pagination_right-end" [class.-enabled]="currentPage < pageCount - 1" (click)="setPageIndex(pageCount - 1)">
      <svg class="table-pagination_right-end_icon"><use xlink:href="#double-arrow-pagination"></use></svg>
    </li>
  </ul>
}

<div class="table-pagination_per-page-select">
  <span class="table-pagination_per-page-select_label">Per page</span>

  <span class="table-pagination_per-page-select_value">
    {{pageSize}}
  </span>
</div>
